var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Switch Camera") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A solid styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M59 18H46.6L40 10H24l-6.6 8H5a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3h54a3 3 0 0 0 3-3V21a3 3 0 0 0-3-3zM38.6 46.3A13.7 13.7 0 0 1 32 48a13.9 13.9 0 0 1-9.9-4.1 14.1 14.1 0 0 1-4-10l-1.5 1.5a2 2 0 1 1-2.8-2.8l6.2-6.3 6.2 6.3a2 2 0 1 1-2.8 2.8l-1.2-1.2a10.1 10.1 0 0 0 2.8 6.9 9.8 9.8 0 0 0 11.7 1.7 2 2 0 0 1 1.9 3.5zm11.6-10.9L44 41.7l-6.2-6.3a2 2 0 1 1 2.8-2.8l1.2 1.2a10.1 10.1 0 0 0-2.8-6.9 9.8 9.8 0 0 0-11.7-1.7 2 2 0 1 1-1.9-3.5 13.9 13.9 0 0 1 16.4 2.4 14.1 14.1 0 0 1 4 10l1.5-1.5a2 2 0 1 1 2.8 2.8z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchCamera);
export default __webpack_public_path__ + "static/media/switch-camera.1c29c5d162e4433d4418bd6647da15fe.svg";
export { ForwardRef as ReactComponent };